import { FC, PropsWithChildren } from "react";
import useLocales from "../../hooks/locale/useLocales";
import LocalesContext from "../../contexts/LocalesContext";

interface ILocalesProviderProps extends PropsWithChildren {
    
}

const LocalesProvider: FC<ILocalesProviderProps> = ({
    children
}) => {
    const locales = useLocales();

    return (
        <LocalesContext.Provider value={locales}>
            {children}
        </LocalesContext.Provider>
    );
}

export default LocalesProvider;